module.exports = __webpack_public_path__ + "media/images/Collage-78583187.webp";